import { RSAA } from 'redux-api-middleware';
import type { RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import type { DealProposalResponse } from '@makemydeal/dr-sales-checkin-types';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { Selectors } from '../selectors';
import { getDealProposalFetchStatus } from './selectors';
import { DEAL_PROPOSAL_FETCH_REQUEST, DEAL_PROPOSAL_FETCH_SUCCESS, DEAL_PROPOSAL_FETCH_FAILURE } from './actionTypes';

export const fetchDealProposals = (selectors: Selectors) => async (dispatch: any, getState: () => any) => {
    const state = getState();
    const endpointUrl = selectors.additionalSelectors.getDealProposalEndpoint(state);
    const dealersInfo = selectors.additionalSelectors.getDealersInfo(state);
    const proposalId = selectors.additionalSelectors.getPublishedProposalId(state);
    if (!endpointUrl || getDealProposalFetchStatus(state) === ApiRequestStatus.Loading) {
        return;
    }

    const request: RSAACallRequest = {
        endpoint: endpointUrl,
        method: 'POST',
        body: JSON.stringify({ dealersInfo, proposalId }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        ok: (res) => res.ok && (res.headers.get('content-type') ?? '').includes('json'),
        types: [
            DEAL_PROPOSAL_FETCH_REQUEST,
            {
                type: DEAL_PROPOSAL_FETCH_SUCCESS,
                payload: (_action: any, _state: any, res: any) => {
                    return res.json().then((data: DealProposalResponse) => data);
                }
            },
            DEAL_PROPOSAL_FETCH_FAILURE
        ],
        fetch: async (...args: Parameters<typeof fetch>) => await fetch(...args)
    };

    await dispatch({ [RSAA]: request });
};
